import smartlookClient from 'smartlook-client';
import { SMARTLOOK_PROJECT_ID } from 'src/constants';
/*
 * Will throw error unless analytics is initialized
 */

export const initSmartLook = (enableSmartLook: any) => {
  if (enableSmartLook) {
    smartlookClient.init(SMARTLOOK_PROJECT_ID);
  }
};
